import { gsap, ScrollTrigger, useGSAP } from '../lib/gsap';

// Reusable scroll/mount reveal for any page. Scope all selectors to a container
// ref so nothing leaks across components, and respect prefers-reduced-motion.
//
//   .reveal       -> fades up on mount (page headers, hero blocks)
//   .reveal-card  -> fades up when scrolled into view, batched + staggered
//
// useGSAP auto-reverts tweens AND ScrollTriggers on unmount (route change).
export function useReveal(scopeRef) {
    useGSAP(() => {
        const mm = gsap.matchMedia();

        mm.add('(prefers-reduced-motion: no-preference)', () => {
            const headers = gsap.utils.toArray('.reveal', scopeRef.current);
            if (headers.length) {
                gsap.from(headers, {
                    opacity: 0,
                    y: 24,
                    duration: 0.6,
                    ease: 'power2.out',
                    stagger: 0.08,
                });
            }

            const cards = gsap.utils.toArray('.reveal-card', scopeRef.current);
            if (cards.length) {
                gsap.set(cards, { opacity: 0, y: 28 });
                ScrollTrigger.batch(cards, {
                    start: 'top 88%',
                    once: true,
                    onEnter: (els) =>
                        gsap.to(els, {
                            opacity: 1,
                            y: 0,
                            duration: 0.6,
                            ease: 'power2.out',
                            stagger: 0.1,
                            overwrite: true,
                        }),
                });
            }
        });

        mm.add('(prefers-reduced-motion: reduce)', () => {
            gsap.set(gsap.utils.toArray('.reveal, .reveal-card', scopeRef.current), {
                clearProps: 'all',
                opacity: 1,
                y: 0,
            });
        });

        return () => mm.revert();
    }, { scope: scopeRef });
}
